export default __webpack_public_path__ + "static/filter-referrer-and-breakdown-dark-mode-624811cffacca2a4aec8712bcd49f38c.png";